<template>
  <GenericReport
    ref="report"
    class="maxh-1bar clean-list"
    hide-header
    orientation="horizontal"
    :reportSpec="reportSpec"
    :adapterSpec="adapterSpec"
    :extraParams="{ clientIds: value.id }"
    @rowClicked="showRowDetails"
    :selectable="true"
    @update:selected="(v) => (selected = v)"
    rememberLastClick
  >
    <template v-slot:topbar-actions>
      <v-spacer />

      <MailboxDetailsDialog ref="detailsDialog" />

      <NewMailboxDialog
        ref="dialog"
        :client="value"
        @reload="$refs.report.reload()"
      />

      <v-btn color="primary" @click="newItem">
        Novo Mailbox...
      </v-btn>

      <OMenuButton :menuOpts="menuOpts" class="ml-2" />
    </template>
  </GenericReport>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { fullSpec } from './mailbox-columns'
import NewMailboxDialog from './NewMailboxDialog.vue'
import MailboxDetailsDialog from './DetailsDialog.vue'
import { MailboxItem } from '@/models'

export default {
  // chamado pelo TabbedInterface qdo a tab é ativada
  expose: ['reload'],
  tabTitle: 'Mailbox',
  tabGroup: 'Módulo',
  // tabBadgeFn: async (client) => {},
  components: {
    GenericReport,
    NewMailboxDialog,
    MailboxDetailsDialog
  },
  props: {
    value: { required: true }
  },
  data() {
    return { adapterSpec: fullSpec, selected: [] }
  },
  computed: {
    reportSpec() {
      let apiBase = `/mailbox`
      return {
        code: 'mailbox',
        title: 'Mailbox',
        apiBase,
        filters: [
          'DateRange',
          { type: 'MailboxInfo', prefix: 'information', noSuffix: true }
        ]
      }
    },

    menuOpts() {
      return [
        {
          text: 'Cancelar...',
          onClick: () => this.cancelItems(),
          disabled: this.selected.length < 1
        },
        {
          text: 'Baixar CSV',
          onClick: () => this.$refs.report.downloadCsv()
        }
      ]
    }
  },
  methods: {
    reload() {
      this.$refs.report.reload()
    },
    newItem() {
      this.$refs.dialog.open()
    },
    showRowDetails({ row }) {
      this.$refs.detailsDialog.open(row.id)
    },

    async cancelItems() {
      let res = await this.$confirm({
        message: 'Deseja realmente cancelar estes itens?',
        okText: 'Sim, cancelar',
        cancelText: 'Não, manter'
      })

      if (res) {
        this.$loading(async () => {
          for (let id of this.selected) {
            await MailboxItem.delete(id)
          }
          this.$snack('Itens cancelados com sucesso')
          this.$emit('reload')
        })
      }
    }
  }
}
</script>

<style></style>
